export default __webpack_public_path__ + "static/media/location-in-modal.ff9e26d6.svg";